import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IArticleEditRouteParams {
    articleId: Guid
}

const ArticleEditRoute = new AppRoute<IArticleEditRouteParams>({
    route: "/article/:articleId/edit",
    navbar: true,
    authRequired: true,
})

export default ArticleEditRoute
